import { useEffect } from "react";

// icons
import { SvgCross as CloseIcon } from "assets/icons/js/SvgCross";

// styles
import "./styles.scss";

const PopUpDrawer = ({
	open,
	setOpen,
	children,
	title,
	className,
	...options
}) => {
	useEffect(() => {
		if (document.getElementById("popup")) {
			let modal = document.getElementById("popup");
			window.onclick = function (event) {
				if (event.target === modal) {
					const container = document.querySelector(".popup-drawer-container");
					if (container) {
						if (window.innerWidth > 800) {
							container.style.transition = "0.3s ease-out";
							container.style.bottom = "0";
							container.style.opacity = "0";
						} else {
							container.style.transition = "0.3s linear";
							container.style.bottom = "-200px";
						}
					}
					setTimeout(() => {
						setOpen(false);
					}, 300);
				}
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);
	useEffect(() => {
		if (open) {
			document.body.style.overflowY = "hidden";
		}
		return () => {
			document.body.style.overflowY = "auto";
		};
	}, [open]);

	if (open)
		return (
			<div
				className={`popup-drawer-wrapper ${className ? className : ""}`}
				{...options}
				id="popup"
			>
				<div className="popup-drawer-container">
					{title && <div className="popup-title">{title}</div>}
					<span
						className="web-only"
						style={{
							position: "absolute",
							right: "16px",
							top: "16px",
							cursor: "pointer",
						}}
						onClick={() => setOpen(false)}
					>
						<CloseIcon width={16} />
					</span>
					<div className="popup-children">{children}</div>
				</div>
			</div>
		);
	return null;
};

export default PopUpDrawer;
